import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import "./narbar.scss";

const Nav: React.FC = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (
        <>
            <nav className="nav-hero">
                <div className="contain-wrapper">
                    <div className="contain nav-wrapper">
                        <Link to="/home" className="logo">
                            {isMobile ? (
                                <img src="/ui/logo.svg" alt="logo" />
                            ) : (
                                <img src="/ui/full-logo.svg" alt="logo" />
                            )}
                        </Link>
                        <div className="menu">
                            <Link to="/about" >
                                <h4>About</h4>
                            </Link>
                            <Link to="/portfolio">
                                <h4>Portfolio</h4>
                            </Link>
                            <Link to="/contact" >
                                <h4>Contact</h4>
                            </Link>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
};
export default Nav;
